export interface Shipments {
  isSelected: boolean;
  id: number;
  coupon_id?: string;
  inventory_id?: number;
  campaign_id?: number;
  order_id?: any;
  shipment_type: number;
  shipment_type_label?: string;
  shopify_order_id?: number;
  fulfilled_on_shopify?: boolean;
  first_name: string;
  last_name?: string;
  customer_name?: string;
  email: string;
  calling_code: string;
  phone: string;
  address1: string;
  address2?: string;
  address3?: string;
  landmark?: string;
  city: string;
  state: string;
  country: string;
  pincode: string;
  status?: number;
  status_label?: string;
  paid?: boolean;
  placed_by?: number;
  place_by_first_name?: string;
  place_by_last_name?: string;
  awb?: string;
  awb_track_url?: string;
  order_notes?: string;
  dispatch_date: string;
  active: boolean;
  cancelled: boolean;
  feedback_message?: string;
  length?: string | number;
  breadth?: string | number;
  height?: string | number;
  weight?: string | number;
  alternate_email_id?: string;
  alternate_phone?: string;
  dispatch_status?: number;
  placed_by_admin_id?: number;
  placed_by_admin_name?: string;
  employee_id?: number;
  delivery_partner_id?: string | number;
  shipping_cost?: number;
  packs_label?: string;
  pack_products_label?: string;
  expected_delivery_date: string;
  delivered_status_date?: string;
  status_change_date?: string;
  shipped_status_date?: string;
  created_date: string;
  delivery_partner_name?: string;
  shipment_method?: ShipmentMethod;
  modified_date: string;
  modified_by_id?: number;
  modified_by_name?: string;
  inventory_type: number;
  size_from_recipient?: string;
}
export interface ShipmentsDetails {
  id?: number;
  first_name?: string;
  last_name?: string;
  email?: string;
  order_notes?: string;
  address1?: string;
  address2?: string;
  country?: string;
  state?: string;
  city?: string;
  pincode?: string;
  phone?: string;
  alternate_phone?: string;
  expected_delivery_date?: string;
  delivered_status_date?: string;
  status_change_date?: string;
  shipped_status_date?: string;
  delivery_partner_id?: string | number;
  delivery_partner_name?: string;
  dispatch_date?: string;
  status?: number;
  status_label?: string;
  awb?: string;
  awb_track_url?: string;
  additional_awb?: string;
  shipping_cost?: number;
  length?: string | number;
  breadth?: string | number;
  height?: string | number;
  weight?: string | number;
  shipment_method?: ShipmentMethod;
}
export enum ShipmentMethod {
  RAIL = "RAIL",
  SURFACE = "SURFACE",
  AIR = "AIR",
}
export interface DeliveryPartner {
  active: number;
  bank_details_link?: string;
  company_website_link?: string | null;
  created_by: number;
  created_date: string;
  delivery_partner_id: number;
  delivery_partner_name: string;
  email?: string;
  gst_number?: string;
  gstin_certificate_link?: string;
  is_logistics_vendor?: number;
  is_printer?: number;
  is_product_supplier?: number;
  modified_date: string;
  msme_link?: string | null;
  pan_card_link?: string;
  pan_number?: string;
  payment_term?: string;
  products_catalog_link?: string | null;
}
export interface BulkUpdate {
  all_selected?: boolean;
  shipment_ids?: number[];
  length?: number;
  breadth?: number;
  height?: number;
  weight?: number;
  status?: number;
  delivery_partner_id?: number;
  shipment_method?: ShipmentMethod;
}
export interface StatusType {
  id: number;
  value: string;
}

export interface Swagpack {
  active: number;
  blocked_quantity: number | null;
  used_quantity: number | 0;
  created_by_name: string;
  created_date: string;
  quantity?: number | string;
  description: string | null;
  id: number;
  inventory_id: number;
  label: string;
  pack_image_url: string;
  products: PackProduct[];
  created_by: number;
  modified_date: string;
}

export interface PackProduct {
  blocked_quantity: number;
  description: string;
  pack_id: number;
  product_id: number;
  product_name: string;
  quantity: number;
  image_url?: string;
  variants?: PackProductVariant[];
  created_date: string;
  modified_date: string;
  selectedVariant?: PackProductVariant[];
  images?: string;
}

export interface PackProductVariant {
  blocked_quantity: number;
  client_sku?: string | null;
  color?: string;
  id: number;
  initial_quantity: number;
  pack_id: number;
  product_id: number;
  quantity: number;
  quantity_allocated_to_shopify?: number;
  quantity_last_synced_to_shopify?: number;
  shopify_variant_id?: string | null;
  size: string;
  total_quantity: number | null;
  created_date: string;
  modified_date: string;
}

export interface TabWiseShipmentsCount {
  tab_id: string;
  label: string;
  requests_count: number;
}
